import breakpoints from '../theme/breakpoints';
import colors from '../theme/colors';

const styleOverrides = {
  root: {
    flexGrow: 0,
    width: '24px',
    [`@media only screen and (min-width: ${breakpoints.md}px)`]: {
      width: '48px',
    },
  },
  line: {
    borderColor: colors.transparentGray['400'],
    borderTopStyle: 'dashed',
  },
};

export default styleOverrides;
